export default __webpack_public_path__ + "static/ssw-logo-45e1087f2cb1e6d9cdfea1fd3093b202.jpg";